(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blossy-colour-edits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('blossy-colour-tabs')) {
 customElements.define('blossy-colour-tabs', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
   this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
   if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
   this.ready = true;
   this.onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (tab && this.contains(tab)) this.activate(this.tabs.indexOf(tab));
   };
   this.onKey = (event) => {
    const index = this.tabs.indexOf(event.target);
    if (index < 0) return;
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;
    event.preventDefault();
    this.activate(next);
    this.tabs[next].focus();
   };
   this.onBlockSelect = (event) => {
    const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
    if (index >= 0) this.activate(index);
   };
   this.addEventListener('click', this.onClick);
   this.addEventListener('keydown', this.onKey);
   document.addEventListener('shopify:block:select', this.onBlockSelect);
   this.querySelector('[role="tablist"]').hidden = false;
   this.dataset.enhanced = 'true';
   this.activate(0);
  }
  activate(index) {
   this.tabs.forEach((tab, i) => {
    tab.setAttribute('aria-selected', String(i === index));
    tab.tabIndex = i === index ? 0 : -1;
    this.panels[i].hidden = i !== index;
   });
  }
  disconnectedCallback() {
   if (!this.ready) return;
   this.removeEventListener('click', this.onClick);
   this.removeEventListener('keydown', this.onKey);
   document.removeEventListener('shopify:block:select', this.onBlockSelect);
   this.ready = false;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blossy-custom-ideas"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.bc-ideas [data-bc-project]');
  if (!link) return;
  const select = document.querySelector('#custom-enquiry select[name="contact[Project]"]');
  if (!select) return;
  select.value = link.dataset.bcProject;
  select.dispatchEvent(new Event('change', { bubbles: true }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
